import { humanize, formatNumber } from '@/utils/format'
import type { ChartPoint } from '../api'

// Validated categorical order (fixed, never cycled): indigo, amber, teal.
const ORDER = ['female', 'male', 'other']
const COLORS = ['#4f46e5', '#d97706', '#0d9488']

/** 100% stacked bar with direct labels — clearer than a donut for 2–3 parts. */
export function SplitBar({ data }: { data: ChartPoint[] }) {
  const rows = ORDER.map((key, i) => ({
    key,
    color: COLORS[i] ?? '#4f46e5',
    value: data.find((d) => d.label === key)?.value ?? 0,
  })).filter((r) => r.value > 0)
  const total = rows.reduce((s, r) => s + r.value, 0) || 1
  return (
    <div>
      <div
        className="flex h-3 gap-0.5 overflow-hidden rounded-full"
        role="img"
        aria-label={rows.map((r) => `${humanize(r.key)} ${r.value}`).join(', ')}
      >
        {rows.map((r) => (
          <span
            key={r.key}
            className="h-full first:rounded-l-full last:rounded-r-full"
            style={{ width: `${(r.value / total) * 100}%`, backgroundColor: r.color }}
            title={`${humanize(r.key)}: ${r.value}`}
          />
        ))}
      </div>
      <ul className="mt-4 space-y-2.5">
        {rows.map((r) => (
          <li key={r.key} className="flex items-center gap-2.5 text-sm">
            <span className="size-2.5 rounded-full" style={{ backgroundColor: r.color }} aria-hidden="true" />
            <span className="flex-1 text-ink-soft">{humanize(r.key)}</span>
            <span className="font-semibold text-ink tabular">{formatNumber(r.value)}</span>
            <span className="w-12 text-right text-xs text-muted tabular">
              {Math.round((r.value / total) * 100)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
